var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconReload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.29289 5.29289L10.2929 3.29289C10.6834 2.90237 11.3166 2.90237 11.7071 3.29289C12.0676 3.65338 12.0953 4.22061 11.7903 4.6129L11.7071 4.70711L11.3892 5.02302C11.5916 5.00771 11.7953 5 12 5C16.4183 5 20 8.58172 20 13C20 17.4183 16.4183 21 12 21C7.58172 21 4 17.4183 4 13C4 12.4477 4.44772 12 5 12C5.55228 12 6 12.4477 6 13C6 16.3137 8.68629 19 12 19C15.3137 19 18 16.3137 18 13C18 9.68629 15.3137 7 12 7C11.8129 7 11.6271 7.00853 11.4429 7.02545L11.7071 7.29289C12.0976 7.68342 12.0976 8.31658 11.7071 8.70711C11.3466 9.06759 10.7794 9.09532 10.3871 8.7903L10.2929 8.70711L8.29289 6.70711C7.93241 6.34662 7.90468 5.77939 8.2097 5.3871L8.29289 5.29289L10.2929 3.29289L8.29289 5.29289Z",
    fill: "#616774"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReload);
export default __webpack_public_path__ + "static/media/IconReload.6bf5f753.svg";
export { ForwardRef as ReactComponent };